export default "__VITE_ASSET__e95bc595__"